import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contact } from './contact.model';

@Injectable()
export class ContactService {
    private resourceUrl = '/api/contacts';

    constructor(private http: HttpClient) {}

    getAllContacts(): Observable<Contact[]> {
        return this.http.get<Contact[]>(this.resourceUrl);
    }

    getContactById(id: number): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/${id}`);
    }

    findContactsByCompanyId(id: number): Observable<any> {
        return this.http.get('/api/companies/' + id + '/contacts');
    }

    save(newItem: any): Observable<any> {
        return this.http.post(this.resourceUrl, newItem);
    }

    create(newContact: Contact): Observable<any> {
        return this.http.post(this.resourceUrl, newContact);
    }

    update(currentContact: Contact): Observable<any> {
        return this.http.put(
            this.resourceUrl + '/' + currentContact.id,
            currentContact
        );
    }

    delete(id: any): Observable<Response> {
        return this.http.delete<Response>(`${this.resourceUrl}/${id}`);
    }

    changeEmailingMode(
        contactId: number,
        emailingMode: string
    ): Observable<any> {
        return this.http.put(`api/contacts/${contactId}/change-emailing-mode`, {
            emailingMode,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/contact/contact.service.ts